export const MED_ICONS = ['tablet', 'pill', 'droplet', 'syringe'];

export const MED_COLORS = [
  '#E53935', // red
  '#FB8C00', // orange
  '#FFB300', // amber
  '#43A047', // green
  '#00ACC1', // cyan
  '#1E88E5', // blue
  '#7E57C2', // purple
  '#EC407A', // pink
  '#00897B', // teal
  '#6D4C41', // brown
  '#FFFFFF', // white
];

export const MED_ICON_DISPLAY_MAP = { tablet: 'circle', pill: 'pill', droplet: 'water', syringe: 'needle' };

export const DEFAULT_ICON = 'pill';
export const DEFAULT_COLOR = '#7E57C2';
